module.exports = __webpack_public_path__ + "static-portal/img/22.fw.a819269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/22.fw.png
// module id = XbuM
// module chunks = 4